import { render, staticRenderFns } from "./ElPostImage.vue?vue&type=template&id=05aecc34"
import script from "./ElPostImage.vue?vue&type=script&lang=js"
export * from "./ElPostImage.vue?vue&type=script&lang=js"
import style0 from "./ElPostImage.vue?vue&type=style&index=0&id=05aecc34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports